import React from 'react'
import Profile from '../../components/superAdmin/profile/Profile'

function ProfilePage() {
  return (
    <div>
        <Profile />
    </div>
  )
}

export default ProfilePage